import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/UserService';
import { CartService } from '../../services/CartService';
import { CartOpen } from '../../models/CartOpen';

@Component({
  selector: 'app-statisticspanel',
  templateUrl: './statisticspanel.component.html',
  styleUrls: ['./statisticspanel.component.css']
})
export class StatisticspanelComponent implements OnInit {

  private userService: UserService;
  public cartService: CartService;
  public numberOfProducts;
  public numberOfOrders;

  currentUserCart;
  numberOfProductsOBS;
  numberOfOrdersOBS;

  constructor( userService: UserService, cartService: CartService) {
    this.userService = userService;
    this.cartService = cartService;
    this.currentUserCart = new CartOpen;
   }

  ngOnDestroy() {

    if (this.numberOfProductsOBS) {

      this.numberOfProductsOBS.unsubscribe();

    }

    if (this.numberOfOrdersOBS) {

      this.numberOfOrdersOBS.unsubscribe();

    }

  }

  ngOnInit() { // Gets the required statistics from the server alongside an observable to a behavior subject on the service in order to check what should be mentioned in terms of cart state.
    
    this.numberOfProductsOBS = this.userService.numberOfProductsOBS.subscribe(val => {

      if (val != -1) {

        this.numberOfProducts = val;

      }

    });

    this.numberOfOrdersOBS = this.userService.numberOfOrdersOBS.subscribe(val => {

      if (val != -1) {

        this.numberOfOrders = val;

      }

    });
    
    // let unneededDateInformation;
    // let creationDate;
    // let orderDate;

    // this.currentCartOBS = this.cartService.currentCartObs.subscribe(val => {

    //   if (val.creation_date != null) {

    //     for (let i = 0; i < val.creation_date.length - 1; i++) {
    //       if (val.creation_date.charAt(i) == "0" && val.creation_date.charAt(i+1) == "0") {
    //         unneededDateInformation = i;
    //         break;
    //       }
    //     }
  
    //     creationDate = val.creation_date.slice(0, unneededDateInformation);

    //   }

    //   if (val.order_date != null) {
    //     for (let i = 0; i < val.order_date.length - 1; i++) {
    //       if (val.order_date.charAt(i) == "0" && val.order_date.charAt(i+1) == "0") {
    //         unneededDateInformation = i;
    //         break;
    //       }
    //     }
  
    //     orderDate = val.order_date.slice(0, unneededDateInformation);
    //   }

    //   this.currentUserCart = {creation_date : creationDate, order_date : orderDate};
    //   });

  }

}
